import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import { LayoutSlice } from './layout.slice';
import { TranslatePageSlice } from './translate.page.slice';
import { ConvertPageSlice } from './convert.page.slice';

export const store = configureStore({
  reducer: {
    [LayoutSlice.name]: LayoutSlice.reducer,

    // Pagtes
    [TranslatePageSlice.name]: TranslatePageSlice.reducer,
    [ConvertPageSlice.name]: ConvertPageSlice.reducer
  },
  devTools: true
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;
